import { useState } from 'react';
import { useCart } from '../context/CartContext';
import { API_BASE_URL } from '../utils/constants';
import { Spinner } from '../components/Spinner';

const Checkout = () => {
  const { cartItems, clearCart } = useCart();
  const [form, setForm] = useState({
    fullName: '',
    email: '',
    country: 'Srbija',
    city: '',
    postalNumber: '',
    address: '',
    phone: '',
    notes: '',
    payWithApp: false,
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await fetch(`${API_BASE_URL}/api/orders`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customer: form,
          cartItems,
        }),
      });

      setSubmitted(true);
      clearCart();
    } catch (err) {
      alert('Failed to place order.');
      console.error(err);
    }
    setLoading(false);
  };

  return (  
        loading ? (
      <Spinner />
    ) : submitted ? (
      <div className="flex items-center justify-center min-h-[40vh]">
        <p className="text-green-600 text-lg text-center">
          Uskoro će Vam stići email o vašoj porudžbini.
        </p>
      </div>
    ) : (
      <div>
        <h2 className="text-2xl text-[var(--text-color)] md:text-2xl font-bold mt-10 text-center">Informacije za poručivanje</h2>
        <form onSubmit={handleSubmit} className="max-w-xl mx-auto p-20 pt-10 space-y-2">
          <input type="text" name="fullName" required value={form.fullName} onChange={handleChange} placeholder="Ime i prezime" className="w-full border p-2 rounded" />
          <input type="email" name="email" required value={form.email} onChange={handleChange} placeholder="Email" className="w-full border p-2 rounded" />
          <input type="text" name="country" required value={form.country} onChange={handleChange} placeholder="Država" className="w-full border p-2 rounded"/>
          <input type="text" name="city" required value={form.city} onChange={handleChange} placeholder="Grad" className="w-full border p-2 rounded" />
          <input type="text" name="postalNumber" required value={form.postalNumber} onChange={handleChange} placeholder="Poštanski broj" className="w-full border p-2 rounded" />
          <input type="text" name="address" required value={form.address} onChange={handleChange} placeholder="Adresa i broj" className="w-full border p-2 rounded" />
          <input type="tel" name="phone" required value={form.phone} onChange={handleChange} placeholder="Broj telefona" className="w-full border p-2 rounded" />
          <textarea name="notes" value={form.notes} onChange={handleChange} placeholder="Dodatno uputstvo (opciono)" className="w-full border p-2 rounded"></textarea>

          <label className="flex items-center gap-2">
            <input type="checkbox" name="payWithApp" checked={form.payWithApp} onChange={handleChange} />
            Štikliraj ako želiš videti podatke za plaćanje putem vaše e-bank aplikacije
          </label>

          {form.payWithApp && (
            <div className="p-4 bg-gray-100 rounded">
              <p className="text-sm">Ime primaoca: Mirta Urošević PR Myrtle Yoga</p>
              <p className="text-sm">Broj računa: 340-1000144371-14</p>
              <p className="text-sm">Ukupno za uplatu: {cartItems.reduce((sum, item) => sum + item.quantity * item.price, 0).toFixed(2)} rsd</p>
            </div>
          )}

          <button type="submit" className="bg-black text-white px-4 py-2 rounded">Poruči</button>
        </form>
      </div>
    )
  );
};

export default Checkout;
